<script>
// import Sellingchart from "./sellingchart";

import OrdersApi from "@/services/orders-api";

export default {
    mounted(){

        this.currentYear = new Date().getFullYear();
        this.selectedYear = this.currentYear;

        //this.getTotalSales()
        //this.getVolumeOfPurchasesBySupplier();
    },
    // components: { Sellingchart},
    data () {
        return {
            total:null,
            suppliersGrid:[],
            chartOptions: {
                chart: {
                    type: "donut"
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                plotOptions: {
                    pie: {
                    donut: {
                        labels: {
                        show: false
                        },
                        size: "65%"
                    }
                    }
                },
                responsive: [
                    {
                    breakpoint: 480,
                    options: {
                        chart: {
                        width: 100
                        }
                    }
                    }
                ],
                colors: ["#f46a6a", "#f8f9fa"]
                },

            currentYear: null,
            selectedYear: null,
                
            }
    },
    methods: {
        getVolumeOfPurchasesBySupplier(){
            OrdersApi.getVolumeOfPurchasesBySupplier(this.selectedYear).then(
            (result)=>{
                this.suppliersGrid=result   
            }
            )
            this.getTotalSales();

        },

        getTotalSales(){
        OrdersApi.getTotalSales(this.selectedYear + "-01-01", this.selectedYear +"-12-31", false).then(
            (result)=>{
                this.total=result
            }
        )
    } 
    },

    watch : {
        selectedYear : function() {
              this.getVolumeOfPurchasesBySupplier() 
        },
  }

};
</script>
<template>
<div class="card mt-2 mb-4 border border-light " >
    <div class="card-body p-0">
        <div class="clearfix m-4">
            <div class="float-right ">
            <div class="input-group input-group-sm">
                <div class="input-group-append">
                <!--label class="input-group-text text-success">{{new Date().getFullYear()}}</label-->

                <select class="custom-select custom-select-sm" v-model="selectedYear">
                    <option selected :value="this.currentYear">{{this.currentYear}}</option>
                    <option v-for="year in Array.from({length: this.currentYear -1 - 2019}, (value, index) => 2020 + index).reverse()" :key="year" :value="year">{{ year }}</option>
                    <!-- <option  :value="this.currentYear-1">{{this.currentYear-1}}</option> -->
                </select>

                </div>
                <div class="input-group-append">
                <label class="input-group-text">Année</label>
                </div>
            </div>
            </div>
            <h4 class="card-title mb-2 font-size-18 text-primary">Volume des Achats par Fournisseur<span class="font-size-12 pl-1">(HT, {{this.selectedYear}})</span></h4>
        </div>
        <div class="table-responsive mt-4 mb-0" style="height:31.25em">
            <table class="table table-centered">
            <tbody>
                <tr v-for="data of suppliersGrid" :key="data.id">
                <td class=" pl-sm-4 ">
                    <img class="d-none d-sm-inline-block" v-bind:src="'/api/image/get/' + data.supplierLogo" alt style="height: 4rem;width: 7rem;border: 1px solid #a09999;padding: 10px; " >
                </td>
                <td>
                    <h5 class="font-size-16 font-weight-bold mb-1">{{data.supplierName}}</h5>
                    <!-- <p class="text-muted mb-0">{{data.description}}</p> -->
                </td>
                <td>
                    <p class="text-muted mb-1">Montant HT</p>
                    <h5 class="mb-0">{{data.sumAsString}}</h5>
                </td>
                <td>
                    <div class="text-muted mb-1 d-none d-sm-inline-block">
                        <p >Pourcentage d'Achats</p>
                        <b-progress 
                            :value="data.sum/total * 100" 
                            variant="success" 
                            height="15px" 
                            show-value>
                        </b-progress>
                    </div>

                </td>
                </tr>
            </tbody>
            </table>
        </div>
        </div>
    </div>
</template>
